import React, { useState } from "react";
import { supabase } from "./lib/supabase";
import "./LandingPage.css";

export default function WaitlistPage() {
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [error, setError] = useState('');

  const isValidEmail = (e) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(e);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const trimmed = email.trim();
    if (!trimmed) { setError('Please enter your email'); return; }
    if (!isValidEmail(trimmed)) { setError('Please enter a valid email'); return; }
    setSubmitting(true);
    setError('');
    try {
      const { error: sbError } = await supabase
        .from('waitlist')
        .insert({ email: trimmed });
      if (sbError && sbError.code === '23505') {
        // Duplicate — still show success (don't reveal they're already on the list)
      } else if (sbError) {
        console.error('Waitlist save error:', sbError.message);
      }
    } catch (err) {
      console.error('Waitlist exception:', err.message);
    }
    setSubmitted(true);
    setSubmitting(false);
  };

  return (
    <div style={{ minHeight: '100dvh', display: 'flex', alignItems: 'center', justifyContent: 'center', background: '#fff' }}>
      <div style={{ textAlign: 'center', width: '100%', maxWidth: 380, padding: '0 1.5rem' }}>
        <a href="/" style={{ textDecoration: 'none' }}>
          <h1 className="lp-nav-logo" style={{ fontSize: '2.2rem', marginBottom: 4 }}>ILIK</h1>
        </a>
        <p style={{ fontFamily: "'Poppins', sans-serif", fontSize: '0.85rem', color: '#999', marginBottom: 48, letterSpacing: '0.04em' }}>
          4 Seasons of You<sup style={{ fontSize: '0.5em' }}>&reg;</sup>
        </p>

        {!submitted ? (
          <form onSubmit={handleSubmit}>
            <h2 style={{ fontFamily: "'Poppins', sans-serif", fontSize: '1.3rem', fontWeight: 700, color: '#212121', marginBottom: 8 }}>
              Join Our Waitlist
            </h2>
            <p style={{ fontFamily: "'Nunito', sans-serif", fontSize: '0.9rem', color: '#757575', lineHeight: 1.6, marginBottom: 28 }}>
              Be the first to know when ILIK launches.
            </p>
            <input
              type="email"
              value={email}
              onChange={(e) => { setEmail(e.target.value); setError(''); }}
              placeholder="Your email address"
              autoFocus
              data-testid="waitlist-email-input"
              style={{
                width: '100%', padding: '14px 16px', borderRadius: 12,
                border: error ? '1.5px solid #E53935' : '1.5px solid #e0e0e0',
                background: '#fafafa', color: '#333', fontSize: '0.95rem',
                fontFamily: "'Nunito', sans-serif", outline: 'none',
                textAlign: 'center', boxSizing: 'border-box',
                transition: 'border-color 0.2s',
              }}
              onFocus={(e) => { if (!error) e.target.style.borderColor = '#FF6F00'; }}
              onBlur={(e) => { if (!error) e.target.style.borderColor = '#e0e0e0'; }}
            />
            {error && (
              <p style={{ color: '#E53935', fontSize: '0.8rem', fontFamily: "'Nunito', sans-serif", marginTop: 8, marginBottom: 0 }}>{error}</p>
            )}
            <button
              type="submit"
              disabled={submitting}
              data-testid="waitlist-submit-btn"
              style={{
                marginTop: 14, width: '100%', padding: '14px',
                borderRadius: 12, border: 'none',
                background: 'linear-gradient(135deg, #FF8F0B, #FF2D78)',
                color: '#fff', fontWeight: 700, fontSize: '0.95rem',
                fontFamily: "'Nunito', sans-serif", cursor: 'pointer',
                letterSpacing: '0.04em', transition: 'opacity 0.15s',
                opacity: submitting ? 0.7 : 1,
              }}
            >
              {submitting ? 'Saving...' : 'Notify Me'}
            </button>
          </form>
        ) : (
          <div data-testid="waitlist-success">
            <p style={{ fontSize: '1.8rem', marginBottom: 12 }}></p>
            <h2 style={{ fontFamily: "'Poppins', sans-serif", fontSize: '1.3rem', fontWeight: 700, color: '#212121', marginBottom: 12 }}>
              Thank You
            </h2>
            <p style={{ fontFamily: "'Nunito', sans-serif", fontSize: '0.9rem', color: '#757575', lineHeight: 1.6 }}>
              We'll let you know as soon as ILIK is launched.
            </p>
            <a
              href="/"
              style={{
                display: 'inline-block', marginTop: 32, padding: '12px 28px',
                borderRadius: 12, background: 'none',
                border: '1.5px solid #e0e0e0', color: '#555',
                fontSize: '0.85rem', fontFamily: "'Nunito', sans-serif",
                fontWeight: 600, textDecoration: 'none',
                transition: 'border-color 0.2s',
              }}
            >
              Back to home
            </a>
          </div>
        )}
      </div>
    </div>
  );
}
